import React from 'react';
import { useStyle } from '../../classify';
import ButtonComponent from 'components/atoms/button/ButtonComponent';

import defaultClasses from './buttonItem.module.css';
import { useSelector } from 'react-redux';
import * as Analytics from 'services/analyticsUtag';

const ButtonItem = props => {
    const classes = useStyle(defaultClasses, props.classes);
    const categoryCmsContent = useSelector(state => state.pageBuilder.categoryCmsContent);

    const {
        buttonType,
        link,
        openInNewTab = false,
        text,
        textAlign,
        border,
        borderColor,
        borderWidth,
        borderRadius,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft,
        cssClasses = []
    } = props;

    const dynamicInnerStyles = {
        textAlign,
        border,
        borderColor,
        borderWidth,
        borderRadius,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft
    };

    const handleClick = event => {
        if (link && buttonType === 'link') {
            const query = new URLSearchParams(window.location.search);
            const categoryId = query.get('range') || query.get('category');
            const clickedItem = event.target.innerText
            Analytics.link({
                link_type: "o",
                page_tool_event: "use",
                page_tool_name: `shopping: ${categoryCmsContent[categoryId]?.name}: ${clickedItem}`,
                ...Analytics.getUtagData([
                    "page_channel",
                    "page_master_tab",
                    "visitor_login_status",
                    "visitor_customer_id",
                    "visitor_id_hash",
                    "visitor_msisdn_hash",
                    "visitor_subscription_type"
                ])
            });
            window.location.href = link;
        }
    };

    const justifyMap = {
        left: 'flex-start',
        center: 'center',
        right: 'flex-end'
    };
    if (textAlign) {
        dynamicInnerStyles.justifyContent = justifyMap[textAlign] || 'center';
        dynamicInnerStyles.textAlign = textAlign;
    }

    const buttonProps = {
        onBtnClick: handleClick
    };

    if (buttonType === 'link') {
        buttonProps.className = classes.linkButton;
    }

    return (
        <div className={cssClasses.length ? cssClasses.join(' ') : undefined}>
            <ButtonComponent {...buttonProps} button text={text} />
        </div>
    );
};

export default ButtonItem;
